import "../styles/index.scss"

import "bootstrap.native"

console.info("Bridgetown is loaded!")
